import { createSelector } from '@reduxjs/toolkit';

import { getModelConceptClassValue } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectAttributesByIriSelector } from 'src/selectors/projectAttributesByIri';
import { projectClassAttributeItemsSelector } from 'src/selectors/projectClassAttributesItems';
import { projectMappingSelector } from 'src/selectors/projectMapping';
import { ReduxState } from 'src/store/types';

export const projectMappingAttributeItemsSelector = memoizeSelectorFactory(
  (projectId: string, mappingId: string) =>
    createSelector(
      projectMappingSelector(projectId, mappingId),
      (state: ReduxState) => state,
      (mapping, state) => {
        if (!mapping || !mapping.to) {
          return [];
        }

        const classIri = getModelConceptClassValue(mapping.to);
        return projectClassAttributeItemsSelector(projectId, classIri)(state);
      }
    )
);

export const projectMappingAttributeIrisSelector = memoizeSelectorFactory(
  (projectId: string, mappingId: string) =>
    createSelector(
      projectMappingAttributeItemsSelector(projectId, mappingId),
      (attributeItems) => attributeItems.map(({ value }) => value)
    )
);

export const projectMappingAttributesSelector = memoizeSelectorFactory(
  (projectId: string, mappingId: string) =>
    createSelector(
      projectMappingAttributeItemsSelector(projectId, mappingId),
      projectAttributesByIriSelector(projectId),
      (attributeItems, attributesByIri) =>
        attributeItems.map(({ value }) => attributesByIri[value])
    )
);
